module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    class: {
      'modal-lg': !_vm.current_user.isSeller()
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.modalTitle))])]), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading",
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": "loading",
      "size": "50px"
    }
  })], 1) : [(!_vm.current_user.isSeller()) ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('span', {
    staticClass: "title light-gray-text"
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.modal_carousel.leadSelect')))]), _c('div', {
    staticClass: "cleafix"
  }, [_vm._v(" ")]), _c('div', {
    staticClass: "table table-modal"
  }, [_c('div', {
    staticClass: "table-header table-row"
  }, [_c('div', {
    staticClass: "table-col contact-list-item-select table-col-collapsed"
  }, [_c('div', {
    staticClass: "checkbox-inline contact-list-item-checkbox-item",
    attrs: {
      "id": "contact-select-all-checkbox"
    },
    on: {
      "click": function($event) {
        return _vm.selectAll()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.selected_all
    }
  }), _c('label', [_vm._v(" ")])])]), _c('div', {
    staticClass: "table-col table-col-empashis table-col-120 contact-list-item-name"
  }, [_vm._v(_vm._s(_vm.$t('integrations.attributes.Responsible')))])]), _c('div', {
    staticClass: "table-body internal-scroller"
  }, [_c('hr'), _vm._l((_vm.users), function(user) {
    return _c('list-item', {
      key: user.id,
      attrs: {
        "user": user,
        "show-checkbox": true,
        "list-carousel": true,
        "userIsSelected": _vm.userIsSelected(user)
      },
      on: {
        "user-selected": _vm.selectUser
      }
    })
  })], 2)])]) : _vm._e(), _c('div', {
    class: {
      'col-md-11': _vm.current_user.isSeller(), 'col-md-5': !_vm.current_user.isSeller()
    }
  }, [_c('div', {
    staticClass: "list-reponsibles"
  }, [_c('span', {
    staticClass: "dark-slate-gray"
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.modal_carousel.lastResponsible')))]), _c('div', {
    staticClass: "draggable-responsible",
    class: {
      'no-last-user': !_vm.has_last_user
    }
  }, [(_vm.has_last_user) ? [_c('div', {
    staticClass: "user-miniature-wrapper"
  }, [_c('div', {
    staticClass: "user-miniature-picture-wrapper"
  }, [_c('img', {
    staticClass: "user-miniature-picture",
    attrs: {
      "src": _vm.carousel.last_user.picture_url
    }
  })])]), _c('div', {
    staticClass: "name light-gray-text"
  }, [_vm._v(_vm._s(_vm.carousel.last_user.name))])] : _c('div', {
    staticClass: "name light-gray-text"
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.modal_carousel.lastResponsibleFeedback')))])], 2), _c('hr', {
    staticClass: "separator"
  }), _c('span', {
    staticClass: "dark-slate-gray"
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.modal_carousel.nextResponsibles')))]), _c('div', {
    staticClass: "responsible-wrapper internal-scroller"
  }, [_c('draggable', {
    attrs: {
      "value": _vm.selected_users,
      "options": _vm.draggable_options
    },
    on: {
      "input": _vm.changeOrder
    }
  }, _vm._l((_vm.selected_users), function(carousel_user) {
    return _c('div', {
      staticClass: "draggable-responsible clickable"
    }, [(_vm.carousel && _vm.carousel.next_user_id == carousel_user.user_id) ? _c('img', {
      staticClass: "green-arrow",
      attrs: {
        "src": require("../../assets/images/arrow.svg")
      }
    }) : _vm._e(), _c('div', {
      staticClass: "user-miniature-wrapper"
    }, [_c('div', {
      staticClass: "user-miniature-picture-wrapper"
    }, [_c('img', {
      staticClass: "user-miniature-picture",
      attrs: {
        "src": carousel_user.user.picture_url
      }
    })])]), _c('div', {
      staticClass: "name light-gray-text"
    }, [_vm._v(_vm._s(carousel_user.user.name))])])
  }), 0)], 1)])])]], 2), _c('div', {
    staticClass: "clearfix"
  }), _c('div', {
    staticClass: "modal-footer"
  }, [_c('a', {
    staticClass: "btn btn-gray",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), (_vm.current_user.isSeller()) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.ok')))]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ff3c4f7!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/modal_carousel.vue
// module id = 1064
// module chunks = 1